module.exports = __webpack_public_path__ + "img/icon_shz.9d10c501.png";